<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex> Schedule </v-flex>
          <v-flex text-right>
            <v-btn @click="dialog = false" icon>
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Scheduled At</th>
              <th class="text-left">Expires At</th>
              <th class="text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(instance, i) in instances" :key="i">
              <td>
                {{
                  iMoment(
                    instance.scheduledAt.seconds
                      ? instance.scheduledAt.seconds * 1000
                      : instance.scheduledAt
                  ).format("MMMM Do, h:mm a")
                }}
              </td>
              <td>
                {{
                  iMoment(
                    instance.expiresAt.seconds
                      ? instance.expiresAt.seconds * 1000
                      : instance.expiresAt
                  ).format("MMMM Do, h:mm a")
                }}
              </td>
              <td>
                <v-chip small label>
                  <span class="text-uppercase font-weight-medium">
                    {{ instance.state }}
                  </span>
                </v-chip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: {
    instances: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {},
  methods: {
    toggleDialog() {
      this.dialog = !this.dialog;
    },

    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date);
      }
      return new Date();
    },
  },
};
</script>

<style>
</style>